import { Logger } from "../../service/Logger"
import { withLayout } from "../hoc/withLayout"
import { withPackContext } from "../hoc/withPackContext"
import DurationSelect from "./components/DurationSelect"
import Modal from "./components/Modal"
import PackSelect from "./components/PackSelect"
import Submit from "./components/Submit"
import "./styles/servicePage.css"
import DOMPurify from "dompurify"
import React from "react"
import { Spinner } from "react-bootstrap"

export const ServicePage = withPackContext(({ tunnelData, packContext }) => {
  Logger.info("Affichage de la page service", false)

  return !packContext?.packs && !packContext?.isRetail ? (
    <Loading />
  ) : (
    <>
      <DurationSelect />
      <PackSelect />
      <Modal />
      <section className="servicePageLegalMentions">
        {tunnelData?.servicePageLegalMention
          ? tunnelData?.servicePageLegalMention.map((mention) => (
              <p style={mention?.style}>
                <small
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(mention?.description, { ADD_ATTR: ["target"] })
                  }}
                ></small>
              </p>
            ))
          : null}
      </section>
      {!packContext?.isRetail && <Submit />}
    </>
  )
})

const Loading = () => {
  return (
    <div className="sprinner-container">
      <Spinner className="spinner" animation="border" />
    </div>
  )
}
export default withLayout(ServicePage, true, "ServicePage")
